import React from 'react';
import { TextField } from '@mui/material';

/**
 * Checks if the entered text is the admin access code.
 * If so, clears storage/cookies and redirects to the Android init page.
 * Only operates when running on Android.
 */
export function handleAdminAccessCode(text: string): void {
  // @ts-ignore
  if (window.Android) {
    if (text === '####1479') {
      sessionStorage.clear();
      localStorage.clear();
      const name = 'googtrans';
      document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      window.location.href = '/android_init';
    }
  }
}

/**
 * Returns true if running on Android (i.e. admin access input should be shown).
 */
export function isAndroid(): boolean {
  // @ts-ignore
  return !!window.Android;
}

/**
 * Renders an admin access text field on Android devices.
 * Returns null on non-Android. Used on error screens to allow
 * administrators to enter the access code and navigate to the init page.
 */
export function AdminAccessInput({ style }: { style?: React.CSSProperties }) {
  if (!isAndroid()) return null;
  return (
    <TextField
      label="Admin Access"
      variant="outlined"
      size="small"
      fullWidth
      style={style}
      onChange={(e) => handleAdminAccessCode(e.target.value)}
    />
  );
}
